/* ONE BOUT — <ob-contact-form> (sections/contact.liquid, Sprint 4 / F).
   Native HTML validation (required, type=email) stays in charge; this only swaps the browser's generic bubble
   text for the copy from the section settings (empty field / invalid e-mail / consent not checked) and blocks
   double submits. Without JS the form still validates with the browser's own messages. */
class ObContactForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;

    const { msgRequired, msgEmail, msgConsent } = this.dataset;

    this.form.addEventListener('invalid', (event) => {
      const field = event.target;
      field.setCustomValidity('');
      let message = '';
      if (field.validity.valueMissing) message = field.type === 'checkbox' ? msgConsent || msgRequired : msgRequired;
      else if (field.validity.typeMismatch && field.type === 'email') message = msgEmail;
      if (message) field.setCustomValidity(message);
    }, true);

    const reset = (event) => {
      if (event.target.setCustomValidity) event.target.setCustomValidity('');
    };
    this.form.addEventListener('input', reset, true);
    this.form.addEventListener('change', reset, true);

    this.form.addEventListener('submit', (event) => {
      const button = this.form.querySelector('[type="submit"]');
      if (this.form.dataset.submitting === 'true') {
        event.preventDefault();
        return;
      }
      this.form.dataset.submitting = 'true';
      if (button) button.setAttribute('aria-busy', 'true');
    });
  }
}

if (!customElements.get('ob-contact-form')) {
  customElements.define('ob-contact-form', ObContactForm);
}
